import { Feedback, FeedbackInput } from '@@types'
import { gql, useMutation } from '@apollo/client'

type Mutation = {
  saveFeedback: Feedback
}

type Variables = {
  feedbackInfo: FeedbackInput
}

export const GQL_MUTATION_SAVE_FEEDBACK = gql`
  mutation saveFeedback($feedbackInfo: FeedbackInput!) {
    saveFeedback(feedbackInfo: $feedbackInfo) {
      id
    }
  }
`

export const useMutateSaveFeedback = () =>
  useMutation<Mutation, Variables>(GQL_MUTATION_SAVE_FEEDBACK)
